// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import MasonryVideo from "components/layout/Masonry/MasonryVideo";
import MasonryImage from "components/layout/Masonry/MasonryImage";
import Masonry from "components/layout/Masonry/Masonry";
import LoadingContainer from "components/layout/LoadingContainer";
import Loader, { StyledLoaderWrapperFullWidth } from "components/layout/Loader";

// ** Custom Hooks
import useImagesCustomMaxWidth from "hooks/useImagesCustomMaxWidth";

// #####################################################

const columns = {
	phone: 3,
	tablet: 3,
	desktop: 4,
	giant: 4,
};

// #####################################################

const GalleryMasonry = ({ emptyText, triggerRef, galleriesKey }) => {
	const gallery = useSelector((state) => state[galleriesKey]);

	const isAuth = useSelector((state) => state.globalCommon.isAuth);

	const customMaxWidth = useImagesCustomMaxWidth();
	const items = useMemo(() => {
		return gallery?.data.map((media) => {
			if (media.media_type === "photo") {
				return (
					<MasonryImage
						key={media.id}
						contentId={media.id}
						contentAlbum={media.album}
						contentType={media.type}
						contentHeight={media.height}
						contentWidth={media.width}
						contentLikesCount={media.likes}
						contentCommentsCount={media.comments}
						imageVert={media?.images?.vert}
						userId={media.user_id}
						userLogin={media.login}
						userAvatar={media.avatar}
						userOnline={media.online}
						userStatusVip={media.status_vip}
						likes={media.likes}
					/>
				);
			} else if (media.media_type === "video") {
				return (
					<MasonryVideo
						key={media.id}
						contentId={media.id}
						contentAlbum={media.album}
						contentType={media.type}
						contentHeight={media.height}
						contentWidth={media.width}
						contentLikesCount={media.likes}
						contentCommentsCount={media.comments}
						contentPreviewVertical={media.thumbs?.preview_vertical}
						contentSourceFull={media.video}
						contentPosterVertical={media.thumbs?.poster_vertical}
						userId={media.user_id}
						userLogin={media.login}
						userAvatar={media.avatar}
						userOnline={media.online}
						userStatusVip={media.status_vip}
						likes={media.likes}
					/>
				);
			}
		});
	}, [gallery?.data, gallery?.mediaType, isAuth]);

	// #####################################################

	return (
		<>
			{!gallery?.loading &&
				gallery?.loaded &&
				gallery?.data?.length === 0 && (
					<LoadingContainer
						empty
						noContentText={emptyText}
						loaderDefault
					/>
				)}
			{gallery?.data?.length > 0 && gallery.format !== "full" && (
				<Masonry
					columns={columns}
					customMaxWidth={customMaxWidth}
					style={{ marginBottom: gallery?.loading ? "1rem" : 0 }}
				>
					{items}
				</Masonry>
			)}
			{gallery?.loading && (
				<StyledLoaderWrapperFullWidth noMargin>
					<Loader />
				</StyledLoaderWrapperFullWidth>
			)}
			{!gallery?.loading &&
				gallery.format !== "full" &&
				!(
					gallery?.pagination?.currentpage > 0 &&
					gallery?.data?.length === 0
				) && (
					<div
						ref={triggerRef}
						style={{ height: "1px", pointerEvents: "none" }}
					/>
				)}
		</>
	);
};

// #####################################################

export default GalleryMasonry;

// #####################################################
